import hasbroLogo from "../../assets/hasbro-logo.png";

// Hasbro workspace branding — colours sampled from the Hasbro logo artwork
export const HASBRO_COLORS = {
    sky: "#00B7EB",
    blue: "#0087C9",
    deep: "#0065A0",
    navy: "#003B6B",
    teal: "#00ABB3",
};

// Shape consumed by DashboardLayout (sidebar, header, active nav item, avatar)
export const HASBRO_BRAND = {
    logo: hasbroLogo,
    name: "Hasbro",
    tagline: null,
    sidebarBg: `radial-gradient(circle at 30% 20%, ${HASBRO_COLORS.deep}, ${HASBRO_COLORS.navy})`,
    headerBg: `radial-gradient(circle at 70% 50%, ${HASBRO_COLORS.deep}, ${HASBRO_COLORS.navy})`,
    activeLink: "bg-white/15 text-white border border-[#00B7EB]/50",
    activeIcon: "text-[#00B7EB] shrink-0",
    avatar: "bg-[#00B7EB] text-white",
    sectionHeader: "text-white",
    pageBg: `linear-gradient(135deg, ${HASBRO_COLORS.sky} 0%, ${HASBRO_COLORS.deep} 55%, ${HASBRO_COLORS.navy} 100%)`,
};

export const isHasbroRole = role => role === "hasbro" || role === "hasbro-customer";
